import styled from "styled-components";
import { Container } from "../../Components/Grid";
import { responsiveMap } from "../../Components/Grid/_utils/responsiveObserve";
import { DELIVERY_OPTIONS_TRANSITION_DURATION } from "../../Components/DeliveryOptionsStatus/DeliveryOptionsStatus.styled";

export const _HeaderContainer = styled("div")<{
  $top?: number;
  $showDeliveryOptions?: boolean;
  $autoHeight?: boolean;
}>(({ $top, $showDeliveryOptions, $autoHeight }) => {
  const $size = ($showDeliveryOptions ? 2 : 1) * 64;
  return {
    top: $top || 0,
    position: "sticky",
    zIndex: 40,
    minHeight: $autoHeight ? undefined : $size,
    height: $autoHeight ? "auto" : $size,
    maxHeight: $autoHeight ? undefined : $size,
    overflow: $autoHeight ? "hidden" : undefined,
    display: "flex",
    flexDirection: "column",
    transition: `top ${DELIVERY_OPTIONS_TRANSITION_DURATION} ease`,
    width: "100%",
    // [`@media ${responsiveMap.mobile}`]: {
    //   minHeight: 64 * 2,
    //   height: 64 * 2,
    //   maxHeight: 64 * 2,
    // },
    ["& > *"]: {
      flex: 1,
    },
    [".header-mobile-delivery-options > div"]: {
      width: "100%",
      height: "var(--header-mobile-delivery-options-height)",
      background: "#111111",
      transition: `height ${DELIVERY_OPTIONS_TRANSITION_DURATION} ease-in-out`,
      overflow: "hidden",
    },
    ".header-mobile-delivery-options": {
      display: "none",
      // iOS optimization to prevent flickering with sticky + transform
      willChange: "transform",
      backfaceVisibility: "hidden",
      WebkitBackfaceVisibility: "hidden",
      WebkitTransform: "translateZ(0)",
      transform: "translateZ(0)",
    },
    ["@media screen and (max-width: 992px)"]: {
      [".delivery-options"]: {
        height: 0,
      },
      ".header-mobile-delivery-options": {
        display: "block !important",
      },
    },
  };
});

export const _HeaderBar = styled("div")<{}>(() => {
  return {
    ["&:before"]: {
      content: "''",
      display: "block",
      position: "absolute",
      backgroundColor: "#111111",
      height: 66,
      width: "100%",
      left: 0,
      top: -2,
      paddingTop: 2,
    },
  };
});

export const _HeaderFlex = styled(Container)<{}>(() => {
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
    margin: "0 auto",
    maxWidth: 1920,
    width: "100%",
    minHeight: 64,
    ["& > div"]: {
      position: "relative",
    },
    ".header-left-container, .header-right-container": {
      flex: 1,
    },
    [`@media ${responsiveMap.mobile}`]: {
      gap: 24,
      ".header-middle-container": {
        display: "none",
      },
      ".header-left-container": {
        maxWidth: "unset",
        flex: 1,
        ".float-left": {
          marginRight: "auto",
        },
      },
      ".header-right-container": {
        maxWidth: "unset",
        flex: "unset",
      },
    },
    [`@media (max-width: 375px)`]: {
      gap: 10,
      "&, .header-left-container, .header-right-container": {
        gap: 10,
      },
    },
  };
});

export const _HeaderH1 = styled.span(() => {
  return {
    margin: 0,
    display: "flex",
    alignItems: "center",
  };
});

export const _HeaderBottomContainer = styled("div")<{}>(() => {
  return {
    transition: "transform 0.5s ease-in-out",
  };
});
